import { useEffect } from "react";
import { MfaIntro, MfaQr, MfaVerify } from "@/features/auth/components/MfaFlow";
import { useMfa } from "@/features/auth/hooks/useLogin/useMfa";
import { useLogin } from "@/features/auth/hooks/useLogin";
import { useLocation } from 'react-router-dom';
import { t } from '@/i18n';

export default function MfaPage() {
  const { completeMfa } = useLogin();
  const { step, qrCode, manualCode, error, isLoading, setStep, loadQr, verifyOtp, startVerification, returnIntro } = useMfa(completeMfa);

  const location = useLocation();
  const mfaState = location.state?.mfaState;

  useEffect(() => {
    if (mfaState) {
      setStep(t('mfaStep.verify'));
    }
  }, [mfaState]);

  return (
    <>
      {step === t('mfaStep.intro') && (
        <MfaIntro onContinue={() => loadQr()}/>
      )}

      {step === t('mfaStep.qr') && qrCode && (
        <MfaQr qrCode={qrCode} manualCode={manualCode} onRetry={loadQr} onContinue={() => startVerification()} onReturn={() => returnIntro()} error={error} />
      )}

      {step === t('mfaStep.verify') && (
        <MfaVerify onVerify={verifyOtp} isLoading={isLoading} />
      )}
    </>
  );
}

export { MfaPage };
